import { render, staticRenderFns } from "./TheHotSign.vue?vue&type=template&id=dc1a6e4a&scoped=true&lang=pug&"
import script from "./TheHotSign.vue?vue&type=script&lang=js&"
export * from "./TheHotSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1a6e4a",
  null
  
)

export default component.exports